const LOGISTICS_DRIVERS_TIME_RANGE = {
  MONTH: 'month',
};

const LOGISTICS_DRIVERS_PAGE_SIZE = 3000;

const LOGISTICS_DRIVERS_DEFAULT_ORDER = 'asc';

export {
  LOGISTICS_DRIVERS_TIME_RANGE,
  LOGISTICS_DRIVERS_PAGE_SIZE,
  LOGISTICS_DRIVERS_DEFAULT_ORDER,
};
